// src/services/apiClient.js
import axios from 'axios'
import { toast } from 'react-hot-toast'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://api.logiqlink.com/api/v1',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    "ngrok-skip-browser-warning": "true"
  },
})

// Store a reference to the navigate function
let navigateRef = null

// Function to set navigate from outside
export const setNavigate = (navigate) => {
  navigateRef = navigate
}

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors
apiClient.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    const { response } = error

    // Handle 401 Unauthorized
    if (response?.status === 401) {
      // Check if we're already on login page to avoid infinite redirects
      const isLoginPage = window.location.pathname.includes('/admin/login')

      // Clear local storage
      localStorage.removeItem('token')
      localStorage.removeItem('user')

      // Only redirect and show toast if not already on login page
      if (!isLoginPage) {
        toast.error('Your session has expired. Please login again.')

        // Use navigate if available, otherwise use window.location
        if (navigateRef) {
          navigateRef('/admin/login', {
            state: { from: window.location.pathname },
            replace: true
          })
        } else {
          window.location.href = '/admin/login'
        }
      }
    }

    // Handle 403 Forbidden
    if (response?.status === 403) {
      toast.error('You do not have permission to access this resource.')
    }

    // Handle 500 Server Error
    if (response?.status >= 500) {
      toast.error('Server error. Please try again later.')
    }

    // For network errors
    if (!response) {
      toast.error('Network error. Please check your connection.')
    }

    return Promise.reject(error.response?.data || error)
  }
)

export default apiClient